import React, { FC, Fragment, ReactNode } from 'react';
import classNames from 'classnames';
import { Link, useLocation } from 'react-router-dom';
import DoubleArrayRightIcon from 'icons/DoubleArrayRight.icon';
import utils from 'utils';

import './Breadcrumbs.styles.scss';

export type BreadcrumbsLink = {
  to: string;
  text: string;
  icon?: ReactNode | FC;
};

type BreadcrumbsProps = {
  className?: string;
  links?: BreadcrumbsLink[];
};

const Breadcrumbs: React.FC<BreadcrumbsProps> = (props) => {
  const { className, links } = props;

  const classes = classNames('breadcrumbs', className);

  const { pathname } = useLocation();

  return (
    <nav className={classes}>
      {links.map(({ to, text, icon }, index) => {
        const isActive = pathname === to;

        const RenderLink = (
          <Link
            key={to}
            to={to}
            className={classNames({ active: isActive })}
            onClick={(e) => {
              if (isActive) {
                e.preventDefault();
              }
            }}
          >
            {icon && utils.renderIcon(icon)}
            {text}
          </Link>
        );

        if (index === links.length - 1) return RenderLink;

        return (
          <Fragment key={to}>
            {RenderLink}
            <DoubleArrayRightIcon />
          </Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;
